import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Tag } from '../../../app/app.interfaces';
import { TagService } from '../../../services/tag.service';


@Component({
  selector: 'tag-selector',
  templateUrl: 'tag-selector.html'
})

export class TagSelector implements OnInit {

  @Input() formControl: FormControl;
  @Input() readonly tags: Tag[] = [];

  plainTags: Tag[] = [];

  constructor() {
  }

  ngOnInit(): void {
    this.plainTags = TagService.makePlain(this.tags);
  }

  addTag(title: string): Tag {
    return { title };
  }

}



// WEBPACK FOOTER //
// ./src/partials/tags/tag-selector/tag-selector.ts